import React, { useState } from 'react';
import { FormInstance } from 'antd';
import { PhoneInput, Form, Col, Row, Input } from '@common/components';
import { TimeZoneSelect } from '@identity/components';
import { WorksMembershipRoleSelect } from 'works/legacy/components/works-membership-role-select/works-membership-role-select';
import { capitalizeFirstLetter } from '@common/services';
import { RolePermissionModal } from '@identity/components/role-permission-modal/role-permission-modal';
import { RolesInfoButton } from '@identity/components/roles-info-button/roles-info-button';

type Props = {
  form: FormInstance;
  entityType: string;
};

export function MemberViewEditForm({ form, entityType }: Props) {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  function capitalizeNames() {
    form.setFieldsValue({
      firstName: capitalizeFirstLetter(form.getFieldValue('firstName')),
      lastName: capitalizeFirstLetter(form.getFieldValue('lastName')),
    });
  }

  return (
    <>
      <RolePermissionModal
        visible={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
      />
      <Form layout="vertical" onBlur={capitalizeNames} form={form}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: 'Please enter the first name',
                },
              ]}
              name="firstName"
              label="First Name"
            >
              <Input size="large" placeholder="Enter first name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              rules={[
                { required: true, message: 'Please enter the last name' },
              ]}
              name="lastName"
              label="Last Name"
            >
              <Input size="large" placeholder="Enter last name" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              rules={[
                {
                  required: true,
                  type: 'email',
                  message: 'Please enter a valid email',
                },
              ]}
              name="email"
              label="Email"
            >
              <Input placeholder="Enter email" size="large" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="employeeId" label="Employee ID">
              <Input size="large" placeholder="Enter Employee ID" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="phone"
              label="Phone Number"
              rules={[
                {
                  pattern: /^(\d{3}-){2}\d{4}$/,
                  message: 'Phone numbers must be in xxx-xxx-xxxx format.',
                  required: false,
                },
              ]}
            >
              <PhoneInput size="large" placeholder="Enter phone number" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <>
            <Col span={12}>
              <Form.Item
                rules={[{ required: true, message: 'Please select a role' }]}
                name="role"
                label={
                  <>
                    <span>Role</span>
                    {entityType === 'organization' && (
                      <RolesInfoButton
                        onClick={() => setShowConfirmModal(true)}
                      />
                    )}
                  </>
                }
              >
                <WorksMembershipRoleSelect placeholder="Select Role" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="title" label="Title">
                <Input size="large" placeholder="Enter title" />
              </Form.Item>
            </Col>
          </>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="timeZone"
              label="Time Zone"
              rules={[{ required: true, message: 'Please select a Time Zone' }]}
            >
              <TimeZoneSelect placeholder="Select Time Zone" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
}
